export const Dollar = ({ width = 20, height = 20, fill = 'white' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_151_2039)">
        <path
          d="M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433284 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7363 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0ZM10 18C8.41775 18 6.87104 17.5308 5.55544 16.6518C4.23985 15.7727 3.21447 14.5233 2.60897 13.0615C2.00347 11.5997 1.84504 9.99113 2.15372 8.43928C2.4624 6.88743 3.22433 5.46197 4.34315 4.34315C5.46197 3.22433 6.88743 2.4624 8.43928 2.15372C9.99113 1.84504 11.5997 2.00346 13.0615 2.60896C14.5233 3.21447 15.7727 4.23984 16.6518 5.55544C17.5308 6.87103 18 8.41775 18 10C18 12.1217 17.1572 14.1566 15.6569 15.6569C14.1566 17.1571 12.1217 18 10 18Z"
          fill={fill}
        />
        <path
          d="M10 9C8 9 8 8.37 8 8C8 7.63 8.7 7 10 7C11.3 7 11.39 7.64 11.4 8H13.4C13.3865 7.31875 13.1415 6.66241 12.7053 6.13896C12.269 5.61551 11.6676 5.25614 11 5.12V4H9V5.09C7 5.42 6 6.71 6 8C6 9.12 6.52 11 10 11C12 11 12 11.68 12 12C12 12.32 11.38 13 10 13C8.16 13 8 12.14 8 12H6C6 12.92 6.66 14.55 9 14.92V16H11V14.92C13 14.58 14 13.29 14 12C14 10.88 13.48 9 10 9Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_151_2039">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
